import { useState, useEffect, useCallback } from 'react';
// import CustomerReportsService from '@/services/CustomerReportsService';
import ReportsService from '@/services/reportsService';
import { toast } from 'react-hot-toast';


const useCustomerReport = (initialFilters = {}) => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branchSummary, setBranchSummary] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState({
    period: initialFilters.period,
    startDate: initialFilters.startDate,
    endDate: initialFilters.endDate,
    branchId: initialFilters.branchId,
    minVisits: initialFilters.minVisits,
    minSpent: initialFilters.minSpent,
    offset: initialFilters.offset ?? 0,
    limit: initialFilters.limit ?? 25,
  });

  
  // Fetch data

const fetchCustomerInsights = useCallback(async () => {
  try {
    setLoading(true);

    const payload = { ...filters };

    if (payload.startDate && payload.endDate) {
      delete payload.period;
    }

    if (payload.period) {
      delete payload.startDate;
      delete payload.endDate;
    }

    Object.keys(payload).forEach((key) => {
      if (
        payload[key] === undefined ||
        payload[key] === null ||
        payload[key] === ""
      ) {
        delete payload[key];
      }
    });

    const response = await ReportsService.getAll(payload);

    setData(response?.data ?? []);
    setSummary(response?.summary ?? null);
    setBranchSummary(response?.branchSummary ?? []);
  } catch (err) {
    console.error(err);
    setError("Failed to load customer insights");
    toast.error("Failed to load Customer Insights report");
  } finally {
    setLoading(false);
  }
}, [filters]);


  useEffect(() => {
    fetchCustomerInsights();
  }, [fetchCustomerInsights]);

  return {
    data,
    summary,
    branchSummary,
    loading,
    error,
    setFilters,
    refreshCustomerInsights: fetchCustomerInsights,
  };
};

export default useCustomerReport;
